import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=655836c9&scoped=true"
import script from "./EN.vue?vue&type=script&setup=true&lang=js"
export * from "./EN.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EN.vue?vue&type=style&index=0&id=655836c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@7.1.4_@rspack+core@1.6.4_webpack_08065c3798326c3f5ad66b50d2011f97/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655836c9",
  null
  
)

export default component.exports